import React, { useState, useEffect, useRef } from "react";
import ContactVendorleadsModal from "../../components/ContactVendorleadsModal";
import SignInModal from "../../components/SignInModal";
import Navbar from "../../components/Navbar";

const BRAND_COLOR = "#1a3f6b";
const BRAND_ACCENT_COLOR = "#10b981";
const BRAND_BLUE = "#3b82f6";
const GRAY_DARK_COLOR = "#374151";

/* ─────────── Demo data (mirrors real DB rows) ─────────── */
const DEMO_AGENCY = {
  agency_name: "Demo Agency",
  agent_name: "John Doe",
  agent_first_name: "John",
  agent_title: "Licensed Agent",
  agent_phone: "0400 000 000",
  agent_colour: "#000000",
  landing_page_slug: "demo-agency",
  logo_url:
    "https://realestate-reports-assets.s3.us-west-2.amazonaws.com/agencies/demo-agency/logo_url_1774836185_14b54735.png",
  profile_image_url:
    "https://realestate-reports-assets.s3.us-west-2.amazonaws.com/agencies/demo-agency/profile-image.jpg",
};

const SEVIRA = {
  obfuscated_id: "vl3272ep",
  profile_slug: "22-sevira-avenue-gledswood-hills-nsw-2557",
  street_short: "22 Sevira Ave",
  suburb_short: "Gledswood Hills",
  photo_url_full:
    "https://b.domainstatic.com.au/2020434661_1_1_251119_021840-w1600-h1200",
};

const SEVIRA_LINK = `https://www.homeprice.site/p/${SEVIRA.profile_slug}-${SEVIRA.obfuscated_id}?agent=${DEMO_AGENCY.landing_page_slug}&campaign=sms`;
const SEARCH_LINK = `https://www.homeprice.site/property-search?agent=${DEMO_AGENCY.landing_page_slug}&campaign=sms`;

/* ─────────── Contact list for animations ─────────── */
const CONTACTS = [
  { id: "c1", first: "Sarah",   last: "Mitchell",  init: "SM", colour: "#f97316", segment: "appraisal", suburb: "Gledswood Hills", street: "8 Banks Ave",       slug: "8-banks-avenue-gledswood-hills-nsw-2557-vl91ka2m" },
  { id: "c2", first: "James",   last: "Chen",      init: "JC", colour: "#3b82f6", segment: "cold",      suburb: "Eastwood",         street: "12 Banksia St",     slug: null },
  { id: "c3", first: "Olivia",  last: "Nguyen",    init: "ON", colour: "#a855f7", segment: "appraisal", suburb: "Gledswood Hills", street: "22 Sevira Ave",     slug: SEVIRA.profile_slug + "-" + SEVIRA.obfuscated_id },
  { id: "c4", first: "Marcus",  last: "Patel",     init: "MP", colour: "#10b981", segment: "past",      suburb: "Harrington Park", street: "7 Lakeside Cres",   slug: "7-lakeside-crescent-harrington-park-nsw-2567-vl4ggbb2" },
  { id: "c5", first: "Emily",   last: "Robertson", init: "ER", colour: "#ec4899", segment: "cold",      suburb: "Liverpool",        street: "18 Garrick Rd",     slug: null },
  { id: "c6", first: "Daniel",  last: "Kowalski",  init: "DK", colour: "#f59e0b", segment: "appraisal", suburb: "Camden",           street: "5 Ridgeline Dr",    slug: "5-ridgeline-drive-camden-nsw-2570-vlqq31fr" },
  { id: "c7", first: "Priya",   last: "Singh",     init: "PS", colour: "#06b6d4", segment: "past",      suburb: "Prestons",         street: "3 Currawong Pl",    slug: "3-currawong-place-prestons-nsw-2170-vl9d1ze4" },
  { id: "c8", first: "Thomas",  last: "Walker",    init: "TW", colour: "#6366f1", segment: "cold",      suburb: "Campbelltown",     street: "104 Northbourne",   slug: null },
];

/* ─────────── Keyframes ─────────── */
function GlobalAnimations() {
  return (
    <style>{`
      @keyframes fadeUp {
        0%   { opacity: 0; transform: translateY(8px); }
        100% { opacity: 1; transform: translateY(0); }
      }
      @keyframes fadeIn {
        0%   { opacity: 0; }
        100% { opacity: 1; }
      }
      @keyframes slideInRight {
        0%   { opacity: 0; transform: translateX(14px); }
        100% { opacity: 1; transform: translateX(0); }
      }
      @keyframes slideInLeft {
        0%   { opacity: 0; transform: translateX(-14px); }
        100% { opacity: 1; transform: translateX(0); }
      }
      @keyframes bubblePop {
        0%   { opacity: 0; transform: translateY(10px) scale(0.92); }
        60%  { opacity: 1; transform: translateY(-1px) scale(1.02); }
        100% { opacity: 1; transform: translateY(0) scale(1); }
      }
      @keyframes typingDot {
        0%, 80%, 100% { transform: scale(0.7); opacity: 0.4; }
        40%           { transform: scale(1);   opacity: 1; }
      }
      @keyframes tickPop {
        0%   { transform: scale(0); opacity: 0; }
        60%  { transform: scale(1.25); opacity: 1; }
        100% { transform: scale(1); opacity: 1; }
      }
      @keyframes toastSlideUp {
        0%   { transform: translateY(140%); opacity: 0; }
        100% { transform: translateY(0); opacity: 1; }
      }
      @keyframes ringPulse {
        0%   { transform: scale(0.6); opacity: 0.55; }
        100% { transform: scale(2.2); opacity: 0; }
      }
      @keyframes caretBlink {
        0%, 50%  { opacity: 1; }
        50.01%, 100% { opacity: 0; }
      }
      @keyframes sendWave {
        0%   { transform: translateX(-100%); }
        100% { transform: translateX(120%); }
      }
      @keyframes notifShake {
        0%, 100% { transform: rotate(0deg); }
        20%      { transform: rotate(-10deg); }
        40%      { transform: rotate(10deg); }
        60%      { transform: rotate(-6deg); }
        80%      { transform: rotate(6deg); }
      }
      @keyframes screenGlow {
        0%, 100% { box-shadow: 0 30px 70px rgba(0,0,0,0.45), 0 0 0 0 rgba(16,185,129,0); }
        50%      { box-shadow: 0 30px 70px rgba(0,0,0,0.45), 0 0 60px 0 rgba(16,185,129,0.25); }
      }
      @keyframes barGrow {
        0%   { transform: scaleY(0.1); }
        100% { transform: scaleY(1); }
      }
      @keyframes drift {
        0%   { transform: translateY(0); opacity: 0.55; }
        50%  { transform: translateY(-6px); opacity: 1; }
        100% { transform: translateY(0); opacity: 0.55; }
      }
      @keyframes shimmer {
        0%   { background-position: -200px 0; }
        100% { background-position: 200px 0; }
      }
    `}</style>
  );
}

/* ─────────── tiny presentation helpers ─────────── */
function Kicker({ children, colour = BRAND_ACCENT_COLOR }) {
  return (
    <div
      style={{
        display: "inline-block",
        background: `${colour}1a`,
        color: colour,
        fontSize: "0.72rem",
        fontWeight: 800,
        borderRadius: 6,
        padding: "0.28rem 0.7rem",
        marginBottom: "1rem",
        letterSpacing: "0.08em",
        textTransform: "uppercase",
      }}
    >
      {children}
    </div>
  );
}

function CheckList({ items }) {
  return (
    <ul style={{ listStyle: "none", padding: 0, margin: 0, display: "flex", flexDirection: "column", gap: "0.6rem" }}>
      {items.map((b, i) => (
        <li key={i} style={{ display: "flex", gap: "0.6rem", fontSize: "0.95rem", color: GRAY_DARK_COLOR, lineHeight: 1.55 }}>
          <span
            style={{
              display: "inline-flex",
              alignItems: "center",
              justifyContent: "center",
              width: 20,
              height: 20,
              borderRadius: "50%",
              background: `${BRAND_ACCENT_COLOR}1f`,
              color: BRAND_ACCENT_COLOR,
              fontSize: "0.7rem",
              flexShrink: 0,
              marginTop: 2,
            }}
          >
            ✓
          </span>
          <span>{b}</span>
        </li>
      ))}
    </ul>
  );
}

/* ─────────── iPhone shell ─────────── */
function IPhoneShell({ children, width = 320, glow = false }) {
  return (
    <div
      style={{
        width,
        margin: "0 auto",
        borderRadius: 42,
        background: "linear-gradient(180deg, #1f2937 0%, #0b1220 100%)",
        padding: 8,
        boxShadow: glow
          ? "0 30px 70px rgba(0,0,0,0.45)"
          : "0 30px 70px rgba(0,0,0,0.45)",
        position: "relative",
        animation: glow ? "screenGlow 4s ease-in-out infinite" : "none",
      }}
    >
      {/* side button hints */}
      <div style={{ position: "absolute", left: -2, top: 110, width: 3, height: 28, background: "#0b1220", borderRadius: 2 }} />
      <div style={{ position: "absolute", left: -2, top: 150, width: 3, height: 48, background: "#0b1220", borderRadius: 2 }} />
      <div style={{ position: "absolute", left: -2, top: 210, width: 3, height: 48, background: "#0b1220", borderRadius: 2 }} />
      <div style={{ position: "absolute", right: -2, top: 140, width: 3, height: 70, background: "#0b1220", borderRadius: 2 }} />
      <div
        style={{
          background: "#fff",
          borderRadius: 34,
          overflow: "hidden",
          position: "relative",
          height: 600,
          display: "flex",
          flexDirection: "column",
        }}
      >
        {/* Dynamic island */}
        <div
          style={{
            position: "absolute",
            top: 10,
            left: "50%",
            transform: "translateX(-50%)",
            width: 100,
            height: 26,
            background: "#000",
            borderRadius: 16,
            zIndex: 10,
          }}
        />
        {children}
      </div>
    </div>
  );
}

/* ─────────── Status bar inside the phone ─────────── */
function StatusBar({ time = "10:24" }) {
  return (
    <div
      style={{
        height: 44,
        paddingTop: 14,
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        padding: "14px 22px 0 22px",
        fontSize: 13,
        fontWeight: 700,
        color: "#0f172a",
        flexShrink: 0,
      }}
    >
      <span>{time}</span>
      <span style={{ display: "inline-flex", alignItems: "center", gap: 5 }}>
        <span style={{ display: "inline-flex", gap: 1.5, alignItems: "flex-end" }}>
          <span style={{ width: 3, height: 4, background: "#0f172a", borderRadius: 1 }} />
          <span style={{ width: 3, height: 6, background: "#0f172a", borderRadius: 1 }} />
          <span style={{ width: 3, height: 8, background: "#0f172a", borderRadius: 1 }} />
          <span style={{ width: 3, height: 10, background: "#0f172a", borderRadius: 1 }} />
        </span>
        <span style={{ fontSize: 10, fontWeight: 600 }}>5G</span>
        <span
          style={{
            display: "inline-block",
            width: 22,
            height: 11,
            border: "1.4px solid #0f172a",
            borderRadius: 3,
            position: "relative",
          }}
        >
          <span style={{ position: "absolute", inset: 1, width: "82%", background: "#0f172a", borderRadius: 1 }} />
          <span style={{ position: "absolute", right: -3, top: 3, width: 2, height: 5, background: "#0f172a", borderRadius: 1 }} />
        </span>
      </span>
    </div>
  );
}

/* ─────────── Messages header for the contact thread ─────────── */
function MessagesHeader({ agency = DEMO_AGENCY }) {
  return (
    <div
      style={{
        padding: "4px 12px 10px 12px",
        background: "rgba(247,247,247,0.92)",
        backdropFilter: "blur(10px)",
        borderBottom: "0.5px solid #d1d5db",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: 4,
        flexShrink: 0,
      }}
    >
      <div style={{ position: "relative" }}>
        <img
          src={agency.profile_image_url}
          alt={agency.agent_name}
          style={{ width: 44, height: 44, borderRadius: "50%", objectFit: "cover", border: "1.5px solid #fff" }}
        />
      </div>
      <div style={{ display: "flex", alignItems: "center", gap: 4, fontSize: 11, fontWeight: 600, color: "#0f172a" }}>
        <span>{agency.agent_first_name} · {agency.agency_name}</span>
        <span style={{ color: "#8e8e93", fontSize: 9 }}>›</span>
      </div>
      <div style={{ display: "flex", alignItems: "center", gap: 4, fontSize: 9, color: "#10b981", fontWeight: 600 }}>
        <span style={{ width: 6, height: 6, borderRadius: "50%", background: "#10b981" }} />
        SMS · iMessage
      </div>
    </div>
  );
}

/* ─────────── Bubble ─────────── */
function Bubble({ side = "incoming", children, tail = true, status = null }) {
  const isIn = side === "incoming";
  return (
    <div style={{ display: "flex", flexDirection: "column", alignItems: isIn ? "flex-start" : "flex-end", marginBottom: 6 }}>
      <div
        style={{
          maxWidth: "82%",
          background: isIn ? "#e9e9eb" : "#34c759",
          color: isIn ? "#000" : "#fff",
          borderRadius: 18,
          borderBottomLeftRadius: isIn && tail ? 4 : 18,
          borderBottomRightRadius: !isIn && tail ? 4 : 18,
          padding: "7px 11px",
          fontSize: 13,
          lineHeight: 1.4,
          wordBreak: "break-word",
          animation: "bubblePop 0.35s ease both",
          boxShadow: "0 1px 1px rgba(0,0,0,0.04)",
          whiteSpace: "pre-wrap",
        }}
      >
        {children}
      </div>
      {status && (
        <div style={{ fontSize: 9.5, color: "#8e8e93", marginTop: 2, marginRight: 4, animation: "fadeIn 0.4s ease both" }}>
          {status}
        </div>
      )}
    </div>
  );
}

function TypingBubble() {
  return (
    <div style={{ display: "flex", justifyContent: "flex-start", marginBottom: 6 }}>
      <div
        style={{
          background: "#e9e9eb",
          borderRadius: 18,
          borderBottomLeftRadius: 4,
          padding: "10px 14px",
          display: "inline-flex",
          gap: 4,
          alignItems: "center",
          animation: "bubblePop 0.3s ease both",
        }}
      >
        {[0, 1, 2].map((i) => (
          <span
            key={i}
            style={{
              width: 7,
              height: 7,
              borderRadius: "50%",
              background: "#9ca3af",
              display: "inline-block",
              animation: `typingDot 1.2s ease-in-out ${i * 0.18}s infinite`,
            }}
          />
        ))}
      </div>
    </div>
  );
}

/* ─────────── Inline link chip inside a bubble ─────────── */
function LinkPreview({ photo, title, subtitle, host }) {
  return (
    <div
      style={{
        marginTop: 6,
        background: "#fff",
        borderRadius: 12,
        overflow: "hidden",
        border: "1px solid rgba(0,0,0,0.06)",
        width: "100%",
      }}
    >
      {photo && (
        <div style={{ width: "100%", height: 86, background: "#0f172a" }}>
          <img src={photo} alt="" style={{ width: "100%", height: "100%", objectFit: "cover", display: "block" }} />
        </div>
      )}
      <div style={{ padding: "7px 9px" }}>
        <div style={{ fontSize: 11.5, fontWeight: 700, color: "#0f172a", lineHeight: 1.2 }}>{title}</div>
        {subtitle && <div style={{ fontSize: 10, color: "#64748b", marginTop: 1 }}>{subtitle}</div>}
        <div style={{ fontSize: 9.5, color: "#94a3b8", marginTop: 3, letterSpacing: 0.4, textTransform: "uppercase" }}>
          {host}
        </div>
      </div>
    </div>
  );
}

/* ─────────── HERO PHONE — live SMS scene ─────────── */
/*
   Story timeline (looped):
   0  agency typing dots
   1  intro bubble appears with branded link preview
   2  "Delivered" → "Read"
   3  recipient typing
   4  recipient reply
   5  agency typing
   6  agency response
*/
const HERO_TIMELINE_MS = [600, 1400, 1700, 1300, 1100, 1200, 1800, 2200];

function HeroLiveScene({ isMobile }) {
  const [phase, setPhase] = useState(0);
  const total = HERO_TIMELINE_MS.length;
  const scrollRef = useRef(null);

  useEffect(() => {
    const t = setTimeout(() => setPhase((p) => (p + 1) % total), HERO_TIMELINE_MS[phase]);
    return () => clearTimeout(t);
  }, [phase, total]);

  // autoscroll to bottom on phase change
  useEffect(() => {
    if (scrollRef.current) {
      scrollRef.current.scrollTop = scrollRef.current.scrollHeight;
    }
  }, [phase]);

  const showAgencyTyping1 = phase === 0;
  const showIntro = phase >= 1;
  const introStatus =
    phase === 1 ? "Delivered" :
    phase >= 2  ? "Read 10:24" : null;
  const showRecipientTyping = phase === 3;
  const showReply = phase >= 4;
  const showAgencyTyping2 = phase === 5;
  const showAgencyResp = phase >= 6;
  const showToast = phase === 7;

  return (
    <div style={{ position: "relative", display: "flex", justifyContent: "center" }}>
      <IPhoneShell width={isMobile ? 290 : 320} glow>
        <StatusBar time="10:24" />
        <MessagesHeader />
        <div
          ref={scrollRef}
          style={{
            flex: 1,
            overflowY: "auto",
            padding: "10px 10px 14px 10px",
            background: "#fff",
            scrollBehavior: "smooth",
          }}
        >
          <div style={{ textAlign: "center", fontSize: 10, color: "#8e8e93", margin: "4px 0 10px 0" }}>
            Today 10:24
          </div>

          {showAgencyTyping1 && <TypingBubble />}

          {showIntro && (
            <Bubble side="incoming" status={introStatus}>
              Hi Olivia — John from Demo Agency here. Quick value update on{" "}
              <b>22 Sevira Ave</b>. Median in Gledswood Hills moved{" "}
              <span style={{ color: "#0a7c43", fontWeight: 700 }}>+3.2%</span> this quarter.
              Tap your private report:
              <LinkPreview
                photo={SEVIRA.photo_url_full}
                title="22 Sevira Ave · Free price update"
                subtitle="Estimate · recent sales · activity"
                host="homeprice.site"
              />
            </Bubble>
          )}

          {showRecipientTyping && <TypingBubble />}

          {showReply && (
            <Bubble side="outgoing">
              Wow that's higher than I expected. Can you do a proper appraisal next week?
            </Bubble>
          )}

          {showAgencyTyping2 && <TypingBubble />}

          {showAgencyResp && (
            <Bubble side="incoming">
              Absolutely Olivia 🙌 I've got Tuesday 4pm or Thursday 11am free — which suits?
            </Bubble>
          )}
        </div>

        {/* iMessage input bar */}
        <div
          style={{
            borderTop: "0.5px solid #d1d5db",
            padding: "6px 10px 10px 10px",
            display: "flex",
            alignItems: "center",
            gap: 6,
            background: "#fafafa",
            flexShrink: 0,
          }}
        >
          <div
            style={{
              width: 26, height: 26, borderRadius: "50%",
              background: "#e5e7eb", color: "#6b7280",
              display: "flex", alignItems: "center", justifyContent: "center",
              fontSize: 14, flexShrink: 0,
            }}
          >+</div>
          <div
            style={{
              flex: 1,
              background: "#fff",
              border: "0.5px solid #d1d5db",
              borderRadius: 16,
              padding: "5px 10px",
              fontSize: 12,
              color: "#8e8e93",
            }}
          >
            iMessage
          </div>
        </div>

        {/* Conversion toast that rides over the phone */}
        {showToast && (
          <div
            style={{
              position: "absolute",
              left: 8, right: 8, bottom: 70,
              background: "rgba(15,23,42,0.92)",
              backdropFilter: "blur(8px)",
              borderRadius: 14,
              padding: "9px 11px",
              display: "flex",
              alignItems: "center",
              gap: 10,
              animation: "slideInRight 0.45s ease both",
              boxShadow: "0 18px 40px rgba(0,0,0,0.35)",
              zIndex: 5,
            }}
          >
            <div
              style={{
                width: 30, height: 30, borderRadius: "50%",
                background: BRAND_ACCENT_COLOR,
                display: "flex", alignItems: "center", justifyContent: "center",
                color: "#fff", fontSize: 14, fontWeight: 800,
                animation: "tickPop 0.4s cubic-bezier(0.2,0.9,0.3,1.4) both",
                flexShrink: 0,
              }}
            >✓</div>
            <div style={{ minWidth: 0 }}>
              <div style={{ color: "#fff", fontSize: 11.5, fontWeight: 700 }}>
                Appraisal booked
              </div>
              <div style={{ color: "rgba(255,255,255,0.65)", fontSize: 10 }}>
                Olivia N. · 22 Sevira Ave · synced to CRM
              </div>
            </div>
          </div>
        )}
      </IPhoneShell>

      {/* Floating "vs email" stat */}
      {!isMobile && <div
        style={{
          position: "absolute",
          right: -40,
          bottom: 80,
          background: "#fff",
          borderRadius: 12,
          padding: "10px 12px",
          boxShadow: "0 14px 30px rgba(0,0,0,0.18)",
          border: "1px solid #e5e7eb",
          animation: "drift 5s ease-in-out infinite",
          animationDelay: "0.6s",
          maxWidth: 170,
        }}
      >
        <div style={{ fontSize: 9, fontWeight: 800, letterSpacing: 1, color: "#64748b" }}>
          REPLY-BACK RATE
        </div>
        <div style={{ fontSize: 22, fontWeight: 800, color: BRAND_ACCENT_COLOR, lineHeight: 1.1, marginTop: 2 }}>
          11<span style={{ fontSize: 14 }}>%</span>
        </div>
        <div style={{ fontSize: 9.5, color: "#64748b", marginTop: 2 }}>
          on cold-lead lists
        </div>
      </div>}
    </div>
  );
}

/* ─────────── Contact list segmenting animation ─────────── */
const SEGMENT_DEFS = [
  { key: "all",       label: "All contacts",      colour: "#64748b" },
  { key: "appraisal", label: "Past appraisals",   colour: BRAND_ACCENT_COLOR },
  { key: "cold",      label: "Cold leads",        colour: BRAND_BLUE },
  { key: "past",      label: "Past clients",      colour: "#a855f7" },
];

function SegmentingAnimation({ isMobile }) {
  const [segIdx, setSegIdx] = useState(0);
  useEffect(() => {
    const t = setInterval(() => setSegIdx((i) => (i + 1) % SEGMENT_DEFS.length), 2600);
    return () => clearInterval(t);
  }, []);
  const seg = SEGMENT_DEFS[segIdx];

  const matches = (c) => seg.key === "all" || c.segment === seg.key;

  return (
    <div
      style={{
        background: "linear-gradient(135deg, #0f172a 0%, #1e3a5f 100%)",
        borderRadius: 16,
        padding: isMobile ? "1.25rem" : "1.75rem",
        border: "1px solid rgba(255,255,255,0.08)",
        boxShadow: "0 20px 60px rgba(0,0,0,0.18)",
        position: "relative",
        overflow: "hidden",
      }}
    >
      <div
        style={{
          position: "absolute", inset: 0,
          backgroundImage:
            "linear-gradient(rgba(255,255,255,0.03) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.03) 1px, transparent 1px)",
          backgroundSize: "40px 40px",
          pointerEvents: "none",
        }}
      />
      <div
        style={{
          position: "relative", zIndex: 1,
          display: "grid",
          gridTemplateColumns: isMobile ? "1fr" : "0.85fr 1.15fr",
          gap: isMobile ? 16 : 24,
        }}
      >
        {/* Segment selector */}
        <div>
          <div style={{ color: "rgba(255,255,255,0.7)", fontSize: 10.5, fontWeight: 800, letterSpacing: 1.4, marginBottom: 10, textTransform: "uppercase" }}>
            Segment your list
          </div>
          <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
            {SEGMENT_DEFS.map((s, i) => {
              const active = i === segIdx;
              return (
                <div
                  key={s.key}
                  style={{
                    display: "flex", alignItems: "center", gap: 10,
                    padding: "9px 12px",
                    borderRadius: 10,
                    background: active ? `${s.colour}24` : "rgba(255,255,255,0.04)",
                    border: `1px solid ${active ? s.colour : "rgba(255,255,255,0.08)"}`,
                    transition: "all 0.4s ease",
                  }}
                >
                  <span
                    style={{
                      width: 14, height: 14, borderRadius: "50%",
                      background: active ? s.colour : "transparent",
                      border: `2px solid ${active ? s.colour : "rgba(255,255,255,0.3)"}`,
                      flexShrink: 0,
                    }}
                  />
                  <div style={{ color: "#fff", fontSize: 13, fontWeight: 600, flex: 1 }}>{s.label}</div>
                  <div
                    style={{
                      fontSize: 11, fontWeight: 700,
                      color: active ? s.colour : "rgba(255,255,255,0.5)",
                    }}
                  >
                    {s.key === "all" ? CONTACTS.length : CONTACTS.filter((c) => c.segment === s.key).length}
                  </div>
                </div>
              );
            })}
          </div>
          <div
            style={{
              marginTop: 14,
              padding: "10px 12px",
              borderRadius: 10,
              background: "rgba(255,255,255,0.05)",
              border: "1px solid rgba(255,255,255,0.08)",
              color: "#e2e8f0",
              fontSize: 11.5,
              lineHeight: 1.55,
            }}
          >
            <span style={{ color: BRAND_ACCENT_COLOR, fontWeight: 700 }}>Audience:</span>{" "}
            {seg.key === "all"
              ? "every contact in your CRM."
              : seg.key === "appraisal"
              ? "homeowners you appraised but never listed, the warmest re-engagement audience in the game."
              : seg.key === "cold"
              ? "mobile-only leads, no address on file, sent to your branded search page."
              : "past clients ready for a quarterly price check-in."}
          </div>
        </div>

        {/* Contact list */}
        <div>
          <div style={{ color: "rgba(255,255,255,0.7)", fontSize: 10.5, fontWeight: 800, letterSpacing: 1.4, marginBottom: 10, textTransform: "uppercase" }}>
            {seg.label} · {seg.key === "all" ? CONTACTS.length : CONTACTS.filter((c) => c.segment === seg.key).length} contacts
          </div>
          <div
            style={{
              background: "rgba(255,255,255,0.04)",
              border: "1px solid rgba(255,255,255,0.08)",
              borderRadius: 12,
              padding: 8,
              display: "flex",
              flexDirection: "column",
              gap: 6,
            }}
          >
            {CONTACTS.map((c) => {
              const m = matches(c);
              return (
                <div
                  key={c.id}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 10,
                    padding: "7px 10px",
                    borderRadius: 8,
                    background: m ? "rgba(16,185,129,0.10)" : "rgba(255,255,255,0.02)",
                    border: `1px solid ${m ? "rgba(16,185,129,0.32)" : "rgba(255,255,255,0.05)"}`,
                    opacity: m ? 1 : 0.32,
                    transition: "all 0.5s ease",
                  }}
                >
                  <div
                    style={{
                      width: 28, height: 28, borderRadius: "50%",
                      background: c.colour,
                      color: "#fff", fontWeight: 800, fontSize: 11,
                      display: "flex", alignItems: "center", justifyContent: "center",
                      flexShrink: 0,
                    }}
                  >{c.init}</div>
                  <div style={{ flex: 1, minWidth: 0 }}>
                    <div style={{ color: "#fff", fontSize: 12.5, fontWeight: 600, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                      {c.first} {c.last}
                    </div>
                    <div style={{ color: "rgba(255,255,255,0.55)", fontSize: 10.5 }}>
                      {c.slug ? c.street + ", " + c.suburb : "Mobile only · no address"}
                    </div>
                  </div>
                  {m && (
                    <span
                      style={{
                        fontSize: 9.5, fontWeight: 800,
                        color: BRAND_ACCENT_COLOR,
                        background: "rgba(16,185,129,0.15)",
                        borderRadius: 4,
                        padding: "2px 6px",
                        letterSpacing: 0.5,
                      }}
                    >IN</span>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
}

/* ─────────── AI drafting typing effect ─────────── */
function typeProgress(target, idx) {
  return target.slice(0, idx);
}

const DRAFT_RECIPES = [
  {
    contact: CONTACTS[0], // Sarah Mitchell – appraisal
    text:
      "Hi Sarah, John from Demo Agency. Median in Gledswood Hills moved +3.2% this quarter — your 8 Banks Ave estimate is now $1.42M. Free private report: homeprice.site/p/8-banks-ave…",
  },
  {
    contact: CONTACTS[2], // Olivia Nguyen
    text:
      "Hi Olivia, quick value check on 22 Sevira Ave — fresh sales data just dropped. Your AI report: homeprice.site/p/22-sevira-ave…",
  },
  {
    contact: CONTACTS[4], // Emily Robertson – cold
    text:
      "Hi Emily, John from Demo Agency. Curious what your place is worth? Free AI valuation, no sign-up: homeprice.site/property-search?agent=demo-agency",
  },
  {
    contact: CONTACTS[6], // Priya Singh – past client
    text:
      "Hi Priya, hope you're loving 3 Currawong Pl 🏡 New sales data is in — here's your quarterly value update: homeprice.site/p/3-currawong…",
  },
];

function AiDraftingAnimation({ isMobile }) {
  const [recipeIdx, setRecipeIdx] = useState(0);
  const [charIdx, setCharIdx] = useState(0);
  const [done, setDone] = useState(false);

  const recipe = DRAFT_RECIPES[recipeIdx];

  useEffect(() => {
    setCharIdx(0);
    setDone(false);
    const target = recipe.text;
    const t = setInterval(() => {
      setCharIdx((i) => {
        if (i >= target.length) {
          clearInterval(t);
          setDone(true);
          return i;
        }
        return i + 2;
      });
    }, 18);
    return () => clearInterval(t);
  }, [recipeIdx, recipe.text]);

  useEffect(() => {
    if (!done) return;
    const t = setTimeout(() => setRecipeIdx((i) => (i + 1) % DRAFT_RECIPES.length), 1800);
    return () => clearTimeout(t);
  }, [done, recipeIdx]);

  const typed = typeProgress(recipe.text, charIdx);

  return (
    <div
      style={{
        background: "linear-gradient(135deg, #0f172a 0%, #1e3a5f 100%)",
        borderRadius: 16,
        padding: isMobile ? "1.25rem" : "1.75rem",
        border: "1px solid rgba(255,255,255,0.08)",
        boxShadow: "0 20px 60px rgba(0,0,0,0.18)",
        position: "relative",
        overflow: "hidden",
      }}
    >
      <div
        style={{
          position: "absolute", inset: 0,
          backgroundImage:
            "linear-gradient(rgba(255,255,255,0.03) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.03) 1px, transparent 1px)",
          backgroundSize: "40px 40px",
          pointerEvents: "none",
        }}
      />

      <div style={{ position: "relative", zIndex: 1 }}>
        <div
          style={{
            display: "flex", alignItems: "center", gap: 10,
            marginBottom: 14,
          }}
        >
          <div
            style={{
              width: 32, height: 32, borderRadius: 8,
              background: `${BRAND_ACCENT_COLOR}22`,
              color: BRAND_ACCENT_COLOR,
              display: "flex", alignItems: "center", justifyContent: "center",
              fontSize: 16,
            }}
          >🤖</div>
          <div>
            <div style={{ color: "#fff", fontSize: 13, fontWeight: 700 }}>AI draft for {recipe.contact.first} {recipe.contact.last}</div>
            <div style={{ color: "rgba(255,255,255,0.55)", fontSize: 11 }}>
              Personalised from CRM data · 160 char SMS
            </div>
          </div>
        </div>

        {/* Composer */}
        <div
          style={{
            background: "rgba(255,255,255,0.04)",
            border: "1px solid rgba(255,255,255,0.1)",
            borderRadius: 12,
            padding: 12,
            display: "flex", gap: 12,
            alignItems: "flex-start",
          }}
        >
          <div
            style={{
              width: 36, height: 36, borderRadius: "50%",
              background: recipe.contact.colour,
              color: "#fff", fontWeight: 800, fontSize: 13,
              display: "flex", alignItems: "center", justifyContent: "center",
              flexShrink: 0,
            }}
          >{recipe.contact.init}</div>
          <div style={{ flex: 1, minWidth: 0 }}>
            <div
              style={{
                color: "#e5e7eb",
                fontSize: 13.5,
                lineHeight: 1.55,
                fontFamily: "ui-monospace, SFMono-Regular, monospace",
                minHeight: 110,
              }}
            >
              {typed}
              {!done && (
                <span
                  style={{
                    display: "inline-block",
                    width: 7,
                    height: 14,
                    background: BRAND_ACCENT_COLOR,
                    verticalAlign: "middle",
                    marginLeft: 1,
                    animation: "caretBlink 0.85s steps(2) infinite",
                  }}
                />
              )}
            </div>
            <div
              style={{
                marginTop: 10,
                display: "flex", gap: 6, flexWrap: "wrap",
              }}
            >
              <span style={chipStyle(BRAND_ACCENT_COLOR)}>{`{first_name}`}</span>
              <span style={chipStyle(BRAND_BLUE)}>{`{street}`}</span>
              <span style={chipStyle("#a855f7")}>{`{suburb_trend}`}</span>
              <span style={chipStyle("#f59e0b")}>{`{branded_link}`}</span>
            </div>
          </div>
        </div>

        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginTop: 12, gap: 8, flexWrap: "wrap" }}>
          <div style={{ color: "rgba(255,255,255,0.55)", fontSize: 11 }}>
            Draft {recipeIdx + 1} of {DRAFT_RECIPES.length} · queued for review
          </div>
          <button
            style={{
              border: "none", borderRadius: 8,
              padding: "7px 14px",
              fontSize: 12, fontWeight: 700,
              background: done ? BRAND_ACCENT_COLOR : "rgba(16,185,129,0.4)",
              color: "#fff", cursor: "default",
              boxShadow: done ? "0 4px 14px rgba(16,185,129,0.35)" : "none",
              transition: "background 0.3s",
            }}
          >
            {done ? "✓ Approved" : "Drafting…"}
          </button>
        </div>
      </div>
    </div>
  );
}
function chipStyle(c) {
  return {
    fontSize: 10, fontWeight: 700,
    background: `${c}24`, color: c,
    border: `1px solid ${c}55`,
    padding: "2px 7px", borderRadius: 999,
    letterSpacing: 0.3,
  };
}

/* ─────────── Send wave + delivery/read ticker animation ─────────── */
function SendWaveAnimation({ isMobile }) {
  const [tick, setTick] = useState(0);

  useEffect(() => {
    const t = setInterval(() => setTick((v) => (v + 1) % (CONTACTS.length + 4)), 650);
    return () => clearInterval(t);
  }, []);

  // sequence: send first, then delivered (offset 1), then read (offset 2)
  const status = (i) => {
    if (tick - i >= 3) return "read";
    if (tick - i >= 2) return "delivered";
    if (tick - i >= 1) return "sent";
    return "pending";
  };

  const sentCount = CONTACTS.filter((_, i) => status(i) !== "pending").length;
  const deliveredCount = CONTACTS.filter((_, i) => status(i) === "delivered" || status(i) === "read").length;
  const readCount = CONTACTS.filter((_, i) => status(i) === "read").length;

  return (
    <div
      style={{
        background: "linear-gradient(135deg, #0f172a 0%, #1e3a5f 100%)",
        borderRadius: 16,
        padding: isMobile ? "1.25rem" : "1.75rem",
        border: "1px solid rgba(255,255,255,0.08)",
        boxShadow: "0 20px 60px rgba(0,0,0,0.18)",
        position: "relative",
        overflow: "hidden",
      }}
    >
      <div
        style={{
          position: "absolute", inset: 0,
          backgroundImage:
            "linear-gradient(rgba(255,255,255,0.03) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.03) 1px, transparent 1px)",
          backgroundSize: "40px 40px",
          pointerEvents: "none",
        }}
      />

      <div style={{ position: "relative", zIndex: 1 }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 14, flexWrap: "wrap", gap: 10 }}>
          <div>
            <div style={{ color: "rgba(255,255,255,0.7)", fontSize: 10.5, fontWeight: 800, letterSpacing: 1.4, textTransform: "uppercase" }}>
              Campaign blast
            </div>
            <div style={{ color: "#fff", fontSize: 16, fontWeight: 700, marginTop: 4 }}>
              Sending wave · {sentCount}/{CONTACTS.length}
            </div>
          </div>
          <div style={{ display: "flex", gap: 10 }}>
            <Pill colour="#94a3b8" label="SENT" value={sentCount} />
            <Pill colour={BRAND_BLUE} label="DELIVERED" value={deliveredCount} />
            <Pill colour={BRAND_ACCENT_COLOR} label="READ" value={readCount} />
          </div>
        </div>

        {/* Wave bar */}
        <div
          style={{
            position: "relative",
            height: 6, borderRadius: 999,
            background: "rgba(255,255,255,0.08)",
            overflow: "hidden",
            marginBottom: 14,
          }}
        >
          <div
            style={{
              position: "absolute", inset: 0,
              width: "40%",
              background: `linear-gradient(90deg, transparent, ${BRAND_ACCENT_COLOR}, transparent)`,
              animation: "sendWave 1.8s linear infinite",
            }}
          />
        </div>

        <div
          style={{
            display: "grid",
            gridTemplateColumns: isMobile ? "1fr" : "1fr 1fr",
            gap: 8,
          }}
        >
          {CONTACTS.map((c, i) => {
            const s = status(i);
            return (
              <div
                key={c.id}
                style={{
                  display: "flex", alignItems: "center", gap: 10,
                  padding: "8px 10px",
                  borderRadius: 10,
                  background:
                    s === "pending"
                      ? "rgba(255,255,255,0.03)"
                      : s === "read"
                      ? "rgba(16,185,129,0.10)"
                      : "rgba(59,130,246,0.08)",
                  border: `1px solid ${
                    s === "pending"
                      ? "rgba(255,255,255,0.06)"
                      : s === "read"
                      ? "rgba(16,185,129,0.3)"
                      : "rgba(59,130,246,0.25)"
                  }`,
                  transition: "all 0.45s ease",
                }}
              >
                <div
                  style={{
                    width: 26, height: 26, borderRadius: "50%",
                    background: c.colour, color: "#fff",
                    fontSize: 11, fontWeight: 800,
                    display: "flex", alignItems: "center", justifyContent: "center",
                    flexShrink: 0,
                  }}
                >{c.init}</div>
                <div style={{ flex: 1, minWidth: 0 }}>
                  <div style={{ color: "#fff", fontSize: 12.5, fontWeight: 600, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                    {c.first} {c.last}
                  </div>
                  <div style={{ color: "rgba(255,255,255,0.45)", fontSize: 10 }}>
                    +61 4{(i + 1).toString().padStart(2, "0")} {(i * 137 % 900 + 100)} {(i * 281 % 900 + 100)}
                  </div>
                </div>
                <TickStatus status={s} />
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}

function Pill({ colour, label, value }) {
  return (
    <div
      style={{
        background: `${colour}1a`,
        border: `1px solid ${colour}55`,
        borderRadius: 999,
        padding: "4px 10px",
        display: "inline-flex", alignItems: "center", gap: 6,
      }}
    >
      <span style={{ width: 6, height: 6, borderRadius: "50%", background: colour }} />
      <span style={{ color: colour, fontSize: 10.5, fontWeight: 800, letterSpacing: 0.5 }}>{label}</span>
      <span style={{ color: "#fff", fontSize: 11.5, fontWeight: 700 }}>{value}</span>
    </div>
  );
}

function TickStatus({ status }) {
  if (status === "pending") {
    return (
      <span style={{ color: "rgba(255,255,255,0.35)", fontSize: 11 }}>•••</span>
    );
  }
  if (status === "sent") {
    return <SingleTick colour="#94a3b8" />;
  }
  if (status === "delivered") {
    return <DoubleTick colour="#94a3b8" />;
  }
  return <DoubleTick colour={BRAND_ACCENT_COLOR} />;
}

function SingleTick({ colour }) {
  return (
    <svg width="14" height="10" viewBox="0 0 14 10" style={{ animation: "tickPop 0.35s ease both" }}>
      <polyline points="1,5 5,9 13,1" fill="none" stroke={colour} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

function DoubleTick({ colour }) {
  return (
    <svg width="18" height="10" viewBox="0 0 18 10" style={{ animation: "tickPop 0.35s ease both" }}>
      <polyline points="1,5 5,9 13,1" fill="none" stroke={colour} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
      <polyline points="6,5 10,9 17,1.5" fill="none" stroke={colour} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

/* ─────────── Click-through to valuation page mock ─────────── */
function ClickThroughAnimation({ isMobile }) {
  const STAGES = [
    { key: "inbox", label: "Inbox" },
    { key: "thread", label: "Thread" },
    { key: "tap", label: "Tap link" },
    { key: "loading", label: "Loading" },
    { key: "report", label: "Report" },
    { key: "convert", label: "Booked" },
  ];
  const [stage, setStage] = useState(0);
  useEffect(() => {
    const t = setInterval(() => setStage((s) => (s + 1) % STAGES.length), 1700);
    return () => clearInterval(t);
  }, [STAGES.length]);

  const showInbox = stage <= 0;
  const showThread = stage >= 1 && stage <= 2;
  const showTapRing = stage === 2;
  const showLoading = stage === 3;
  const showReport = stage >= 4;
  const showConvert = stage >= 5;

  return (
    <div
      style={{
        background: "linear-gradient(135deg, #0f172a 0%, #1e3a5f 100%)",
        borderRadius: 16,
        padding: isMobile ? "1.25rem" : "1.75rem",
        border: "1px solid rgba(255,255,255,0.08)",
        boxShadow: "0 20px 60px rgba(0,0,0,0.18)",
        position: "relative",
        overflow: "hidden",
      }}
    >
      <div
        style={{
          position: "absolute", inset: 0,
          backgroundImage:
            "linear-gradient(rgba(255,255,255,0.03) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.03) 1px, transparent 1px)",
          backgroundSize: "40px 40px",
          pointerEvents: "none",
        }}
      />

      <div style={{ position: "relative", zIndex: 1, display: "grid", gridTemplateColumns: isMobile ? "1fr" : "1fr 1.4fr", gap: isMobile ? 18 : 26, alignItems: "center" }}>

        {/* Stage rail */}
        <div>
          <div style={{ color: "rgba(255,255,255,0.7)", fontSize: 10.5, fontWeight: 800, letterSpacing: 1.4, marginBottom: 12, textTransform: "uppercase" }}>
            One tap from SMS to booked appraisal
          </div>
          <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
            {STAGES.map((s, i) => {
              const active = i === stage;
              const done = i < stage;
              return (
                <div
                  key={s.key}
                  style={{
                    display: "flex", alignItems: "center", gap: 10,
                    padding: "9px 12px",
                    borderRadius: 10,
                    background: active ? "rgba(16,185,129,0.14)" : "rgba(255,255,255,0.04)",
                    border: `1px solid ${active ? "rgba(16,185,129,0.4)" : "rgba(255,255,255,0.08)"}`,
                    transition: "all 0.35s ease",
                    opacity: done ? 0.7 : 1,
                  }}
                >
                  <div
                    style={{
                      width: 24, height: 24, borderRadius: "50%",
                      background: active ? BRAND_ACCENT_COLOR : done ? "rgba(16,185,129,0.55)" : "rgba(255,255,255,0.1)",
                      color: "#fff", fontSize: 11, fontWeight: 800,
                      display: "flex", alignItems: "center", justifyContent: "center",
                      flexShrink: 0,
                    }}
                  >{done ? "✓" : i + 1}</div>
                  <div style={{ color: "#fff", fontSize: 12.5, fontWeight: 600 }}>{s.label}</div>
                </div>
              );
            })}
          </div>
        </div>

        {/* Mini phone */}
        <div style={{ display: "flex", justifyContent: "center", position: "relative" }}>
          <div
            style={{
              width: 260, borderRadius: 32,
              background: "linear-gradient(180deg, #1f2937 0%, #0b1220 100%)",
              padding: 7,
              boxShadow: "0 30px 60px rgba(0,0,0,0.45)",
            }}
          >
            <div
              style={{
                background: "#fff", borderRadius: 26, overflow: "hidden",
                height: 460, position: "relative",
                display: "flex", flexDirection: "column",
              }}
            >
              <div
                style={{
                  position: "absolute",
                  top: 8, left: "50%", transform: "translateX(-50%)",
                  width: 80, height: 22, background: "#000", borderRadius: 14, zIndex: 10,
                }}
              />

              {showInbox && (
                <div style={{ paddingTop: 38, animation: "fadeIn 0.4s ease both", flex: 1 }}>
                  <div style={{ padding: "8px 14px 4px 14px", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                    <div style={{ fontSize: 18, fontWeight: 800, color: "#0f172a" }}>Messages</div>
                    <div style={{ fontSize: 18, color: BRAND_BLUE }}>✎</div>
                  </div>
                  {[
                    { who: "John · Demo Agency", preview: "Quick value update on 22 Sevira…", unread: true, profile: DEMO_AGENCY.profile_image_url },
                    { who: "Mum", preview: "Don't forget Sunday lunch ❤️", unread: false },
                    { who: "Westpac", preview: "Your transfer of $250 to…", unread: false },
                  ].map((t, i) => (
                    <div
                      key={i}
                      style={{
                        padding: "10px 14px",
                        borderBottom: "0.5px solid #e5e7eb",
                        display: "flex", gap: 10, alignItems: "center",
                        background: i === 0 ? "rgba(0,122,255,0.04)" : "transparent",
                      }}
                    >
                      <div
                        style={{
                          width: 40, height: 40, borderRadius: "50%",
                          background: i === 0 ? "transparent" : "#e5e7eb",
                          flexShrink: 0,
                          overflow: "hidden",
                          display: "flex", alignItems: "center", justifyContent: "center",
                          color: "#94a3b8", fontWeight: 800, fontSize: 14,
                        }}
                      >
                        {t.profile ? (
                          <img src={t.profile} alt="" style={{ width: "100%", height: "100%", objectFit: "cover" }} />
                        ) : t.who[0]}
                      </div>
                      <div style={{ flex: 1, minWidth: 0 }}>
                        <div style={{ display: "flex", justifyContent: "space-between", gap: 6 }}>
                          <div style={{ fontSize: 13, fontWeight: 700, color: "#0f172a", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>{t.who}</div>
                          <div style={{ fontSize: 10.5, color: "#8e8e93" }}>now</div>
                        </div>
                        <div style={{ fontSize: 11.5, color: t.unread ? "#0f172a" : "#8e8e93", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", marginTop: 1 }}>
                          {t.preview}
                        </div>
                      </div>
                      {t.unread && <span style={{ width: 7, height: 7, borderRadius: "50%", background: BRAND_BLUE, flexShrink: 0 }} />}
                    </div>
                  ))}
                </div>
              )}

              {showThread && (
                <div style={{ animation: "fadeIn 0.4s ease both", paddingTop: 36, flex: 1, display: "flex", flexDirection: "column" }}>
                  <div style={{ padding: "4px 12px 8px 12px", textAlign: "center", borderBottom: "0.5px solid #e5e7eb" }}>
                    <img src={DEMO_AGENCY.profile_image_url} alt="" style={{ width: 38, height: 38, borderRadius: "50%", objectFit: "cover" }} />
                    <div style={{ fontSize: 10, fontWeight: 600, color: "#0f172a", marginTop: 2 }}>John · Demo Agency</div>
                  </div>
                  <div style={{ flex: 1, padding: "10px 8px", overflowY: "auto" }}>
                    <Bubble side="incoming">
                      Hi Olivia — quick value update on 22 Sevira Ave. Median moved +3.2% this quarter. Tap for your private report:
                      <LinkPreview
                        photo={SEVIRA.photo_url_full}
                        title="22 Sevira Ave · Free price update"
                        subtitle="Estimate · sales · activity"
                        host="homeprice.site"
                      />
                    </Bubble>
                  </div>
                  {/* Finger tap ring on the link area */}
                  {showTapRing && (
                    <div
                      style={{
                        position: "absolute",
                        left: 130, top: 230,
                        pointerEvents: "none",
                      }}
                    >
                      <span
                        style={{
                          position: "absolute",
                          left: 0, top: 0,
                          width: 50, height: 50,
                          borderRadius: "50%",
                          border: `2px solid ${BRAND_ACCENT_COLOR}`,
                          animation: "ringPulse 1.1s ease-out infinite",
                        }}
                      />
                      <div style={{ fontSize: 26, transform: "translate(8px, 16px)" }}>👆</div>
                    </div>
                  )}
                </div>
              )}

              {showLoading && (
                <div style={{ paddingTop: 38, flex: 1, display: "flex", flexDirection: "column", animation: "fadeIn 0.4s ease both" }}>
                  <div
                    style={{
                      padding: "6px 10px",
                      borderBottom: "0.5px solid #e5e7eb",
                      display: "flex", alignItems: "center", gap: 6,
                      fontSize: 10, color: "#64748b",
                    }}
                  >
                    <span>🔒</span>
                    <span style={{ flex: 1, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>homeprice.site/p/22-sevira…</span>
                  </div>
                  <div style={{ flex: 1, padding: 16 }}>
                    <div style={{ height: 14, borderRadius: 4, background: "linear-gradient(90deg, #eef2f7, #f8fafc, #eef2f7)", backgroundSize: "400px 100%", animation: "shimmer 1.2s linear infinite", marginBottom: 10 }} />
                    <div style={{ height: 120, borderRadius: 8, background: "linear-gradient(90deg, #eef2f7, #f8fafc, #eef2f7)", backgroundSize: "400px 100%", animation: "shimmer 1.2s linear infinite", marginBottom: 10 }} />
                    <div style={{ height: 14, borderRadius: 4, background: "linear-gradient(90deg, #eef2f7, #f8fafc, #eef2f7)", backgroundSize: "400px 100%", animation: "shimmer 1.2s linear infinite", marginBottom: 6, width: "60%" }} />
                    <div style={{ height: 14, borderRadius: 4, background: "linear-gradient(90deg, #eef2f7, #f8fafc, #eef2f7)", backgroundSize: "400px 100%", animation: "shimmer 1.2s linear infinite", marginBottom: 6, width: "80%" }} />
                  </div>
                </div>
              )}

              {showReport && (
                <div style={{ paddingTop: 38, flex: 1, overflow: "hidden", animation: "fadeIn 0.4s ease both", display: "flex", flexDirection: "column" }}>
                  <div
                    style={{
                      padding: "6px 10px",
                      borderBottom: "0.5px solid #e5e7eb",
                      display: "flex", alignItems: "center", gap: 6,
                      fontSize: 10, color: "#0f172a",
                      background: "#f8fafc",
                    }}
                  >
                    <img
                      src={DEMO_AGENCY.logo_url}
                      alt=""
                      style={{ height: 14, maxWidth: 50, objectFit: "contain" }}
                    />
                    <span style={{ flex: 1, fontWeight: 700 }}>Demo Agency</span>
                    <span style={{ color: BRAND_ACCENT_COLOR, fontSize: 9, fontWeight: 800 }}>BRANDED</span>
                  </div>
                  <div style={{ width: "100%", height: 90, background: "#0f172a" }}>
                    <img src={SEVIRA.photo_url_full} alt="" style={{ width: "100%", height: "100%", objectFit: "cover" }} />
                  </div>
                  <div style={{ padding: "8px 12px" }}>
                    <div style={{ fontSize: 9, color: "#64748b", fontWeight: 700, letterSpacing: 0.5 }}>22 SEVIRA AVE</div>
                    <div style={{ fontSize: 11, color: "#0f172a", fontWeight: 600 }}>Gledswood Hills NSW</div>
                    <div style={{ fontSize: 9, color: BRAND_BLUE, fontWeight: 800, letterSpacing: 0.5, marginTop: 8 }}>AI ESTIMATE</div>
                    <div style={{ fontSize: 22, fontWeight: 800, color: BRAND_COLOR, lineHeight: 1.1 }}>$2.18M</div>
                    <div style={{ fontSize: 9.5, color: "#10b981", fontWeight: 700 }}>+3.2% this quarter</div>

                    <div style={{ display: "flex", gap: 3, alignItems: "flex-end", marginTop: 10, height: 40 }}>
                      {[0.35, 0.5, 0.42, 0.6, 0.55, 0.72, 0.65, 0.8, 0.78, 0.92, 0.88, 1].map((h, i) => (
                        <div
                          key={i}
                          style={{
                            flex: 1,
                            background: `linear-gradient(180deg, ${BRAND_ACCENT_COLOR}, ${BRAND_BLUE})`,
                            height: `${h * 100}%`,
                            borderRadius: 2,
                            transformOrigin: "bottom",
                            animation: `barGrow 0.6s ease both`,
                            animationDelay: `${i * 0.04}s`,
                          }}
                        />
                      ))}
                    </div>

                    <button
                      style={{
                        width: "100%", marginTop: 10,
                        background: BRAND_COLOR, color: "#fff",
                        border: "none", borderRadius: 8,
                        padding: "8px 10px", fontSize: 11, fontWeight: 700,
                        cursor: "default",
                      }}
                    >
                      Request a private appraisal
                    </button>
                  </div>
                </div>
              )}

              {/* conversion toast over the phone */}
              {showConvert && (
                <div
                  style={{
                    position: "absolute",
                    left: 10, right: 10, top: 40,
                    background: "rgba(16,185,129,0.96)",
                    backdropFilter: "blur(6px)",
                    color: "#fff",
                    borderRadius: 12,
                    padding: "9px 11px",
                    display: "flex",
                    alignItems: "center",
                    gap: 9,
                    animation: "slideInRight 0.45s ease both, fadeIn 0.4s ease both",
                    boxShadow: "0 18px 30px rgba(0,0,0,0.3)",
                    zIndex: 5,
                  }}
                >
                  <span style={{ fontSize: 16, animation: "notifShake 0.6s ease both" }}>🔔</span>
                  <div style={{ flex: 1, minWidth: 0 }}>
                    <div style={{ fontSize: 11, fontWeight: 800 }}>New lead in your CRM</div>
                    <div style={{ fontSize: 10, opacity: 0.85 }}>Olivia · clicked → requested appraisal</div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

/* ─────────── Two-way reply scene ─────────── */
function TwoWayReplyScene({ isMobile }) {
  // mini-storyboard: contact reply → AI suggested response → agent approves → sent
  const [stage, setStage] = useState(0); // 0..3
  useEffect(() => {
    const t = setInterval(() => setStage((s) => (s + 1) % 4), 2200);
    return () => clearInterval(t);
  }, []);

  const showReply = stage >= 0;
  const showAiDraft = stage >= 1;
  const showApproved = stage >= 2;
  const showSent = stage >= 3;

  return (
    <div
      style={{
        background: "linear-gradient(135deg, #0f172a 0%, #1e3a5f 100%)",
        borderRadius: 16,
        padding: isMobile ? "1.25rem" : "1.75rem",
        border: "1px solid rgba(255,255,255,0.08)",
        boxShadow: "0 20px 60px rgba(0,0,0,0.18)",
        position: "relative",
        overflow: "hidden",
      }}
    >
      <div
        style={{
          position: "absolute", inset: 0,
          backgroundImage:
            "linear-gradient(rgba(255,255,255,0.03) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.03) 1px, transparent 1px)",
          backgroundSize: "40px 40px",
          pointerEvents: "none",
        }}
      />
      <div style={{ position: "relative", zIndex: 1, display: "grid", gridTemplateColumns: isMobile ? "1fr" : "1fr 1.1fr", gap: isMobile ? 16 : 28, alignItems: "center" }}>
        {/* Phone chat snippet */}
        <div
          style={{
            background: "#fff",
            borderRadius: 18,
            padding: 14,
            boxShadow: "0 14px 30px rgba(0,0,0,0.18)",
          }}
        >
          <div style={{ fontSize: 10, color: "#8e8e93", textAlign: "center", marginBottom: 10 }}>Conversation · Sarah Mitchell</div>
          <Bubble side="incoming">
            Hi Sarah — your 8 Banks Ave is now estimated at $1.42M. Free private report inside 👇
          </Bubble>
          {showReply && (
            <Bubble side="outgoing">
              Interesting — is that a fair price if I sold next year?
            </Bubble>
          )}
          {showSent && (
            <Bubble side="incoming">
              Great question Sarah. Based on Gledswood Hills' trend, listing in autumn '26 could net you another 3-5%. Want a private appraisal Tuesday or Thursday?
            </Bubble>
          )}
        </div>

        {/* AI draft panel */}
        <div>
          <div style={{ color: "rgba(255,255,255,0.7)", fontSize: 10.5, fontWeight: 800, letterSpacing: 1.4, marginBottom: 10, textTransform: "uppercase" }}>
            AI suggests · You approve
          </div>
          <div
            style={{
              background: "rgba(255,255,255,0.05)",
              border: `1px solid ${showApproved ? BRAND_ACCENT_COLOR : "rgba(255,255,255,0.1)"}`,
              borderRadius: 12,
              padding: 14,
              transition: "border 0.3s",
            }}
          >
            <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 8 }}>
              <div
                style={{
                  width: 24, height: 24, borderRadius: 6,
                  background: `${BRAND_ACCENT_COLOR}22`,
                  color: BRAND_ACCENT_COLOR,
                  display: "flex", alignItems: "center", justifyContent: "center",
                  fontSize: 13,
                }}
              >🤖</div>
              <div style={{ color: "#fff", fontSize: 12, fontWeight: 700 }}>
                AI draft reply
              </div>
              {showApproved && (
                <span
                  style={{
                    marginLeft: "auto",
                    background: BRAND_ACCENT_COLOR, color: "#fff",
                    fontSize: 9.5, fontWeight: 800,
                    padding: "2px 8px", borderRadius: 999,
                    letterSpacing: 0.5,
                    animation: "tickPop 0.4s ease both",
                  }}
                >✓ APPROVED</span>
              )}
            </div>
            <div
              style={{
                color: "#e5e7eb",
                fontSize: 12.5,
                lineHeight: 1.55,
                minHeight: 60,
              }}
            >
              {showAiDraft
                ? "Great question Sarah. Based on Gledswood Hills' trend, listing in autumn '26 could net you another 3-5%. Want a private appraisal Tuesday or Thursday?"
                : "Reading reply…"}
            </div>
            <div style={{ display: "flex", gap: 8, marginTop: 12 }}>
              <button
                style={{
                  flex: 1,
                  background: showApproved ? BRAND_ACCENT_COLOR : "rgba(16,185,129,0.4)",
                  color: "#fff", border: "none",
                  borderRadius: 8, padding: "8px 10px",
                  fontSize: 12, fontWeight: 700, cursor: "default",
                  transition: "background 0.3s",
                }}
              >
                {showApproved ? "✓ Sent" : "Approve & send"}
              </button>
              <button
                style={{
                  background: "rgba(255,255,255,0.05)",
                  color: "#fff", border: "1px solid rgba(255,255,255,0.15)",
                  borderRadius: 8, padding: "8px 12px",
                  fontSize: 12, fontWeight: 600, cursor: "default",
                }}
              >Edit</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

/* ─────────── Story sub-blocks for the long page ─────────── */
function StoryBlock({ kicker, title, body, bullets, media, reversed, isMobile }) {
  return (
    <section
      style={{
        padding: isMobile ? "3rem 1.5rem" : "5rem 2rem",
        background: reversed ? "#f8fafc" : "#fff",
        borderTop: "1px solid #f1f5f9",
      }}
    >
      <div
        style={{
          maxWidth: 1140,
          margin: "0 auto",
          display: "flex",
          flexDirection: isMobile ? "column" : reversed ? "row-reverse" : "row",
          alignItems: "center",
          gap: isMobile ? "2.5rem" : "4rem",
        }}
      >
        <div style={{ flex: "1 1 50%", minWidth: 0 }}>
          {media}
        </div>
        <div style={{ flex: "1 1 50%", maxWidth: isMobile ? "100%" : 480 }}>
          <Kicker>{kicker}</Kicker>
          <h2
            style={{
              fontSize: isMobile ? "1.6rem" : "2rem",
              fontWeight: 800,
              color: BRAND_COLOR,
              marginBottom: "1rem",
              lineHeight: 1.2,
              letterSpacing: "-0.01em",
            }}
          >
            {title}
          </h2>
          <p
            style={{
              fontSize: "1rem",
              color: GRAY_DARK_COLOR,
              lineHeight: 1.7,
              marginBottom: "1.5rem",
            }}
          >
            {body}
          </p>
          {bullets && <CheckList items={bullets} />}
        </div>
      </div>
    </section>
  );
}

/* ─────────── Page ─────────── */
export default function SMSCampaigns() {
  const [isMobile, setIsMobile] = useState(typeof window !== "undefined" ? window.innerWidth <= 900 : false);
  const [showContact, setShowContact] = useState(false);
  const [showSignIn, setShowSignIn] = useState(false);

  useEffect(() => {
    const onResize = () => setIsMobile(window.innerWidth <= 900);
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  const heroBg = "linear-gradient(135deg, #0f172a 0%, #1e3a5f 50%, #134e4a 100%)";

  return (
    <div style={{ fontFamily: "Inter, Arial, sans-serif", background: "#fff" }}>
      <GlobalAnimations />
      <Navbar onSignIn={() => setShowSignIn(true)} />

      {/* ─── HERO ─── */}
      <header
        style={{
          background: heroBg,
          padding: isMobile ? "3.5rem 1.25rem 4.5rem 1.25rem" : "6rem 2rem 7rem 2rem",
          position: "relative",
          overflow: "hidden",
        }}
      >
        <div
          style={{
            position: "absolute", inset: 0,
            backgroundImage:
              "linear-gradient(rgba(255,255,255,0.03) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.03) 1px, transparent 1px)",
            backgroundSize: "60px 60px",
            pointerEvents: "none",
          }}
        />
        <div
          style={{
            maxWidth: 1180, margin: "0 auto",
            position: "relative", zIndex: 1,
            display: "grid",
            gridTemplateColumns: isMobile ? "1fr" : "1.05fr 1fr",
            gap: isMobile ? "3rem" : "4rem",
            alignItems: "center",
          }}
        >
          {/* Left text */}
          <div>
            <div
              style={{
                display: "inline-flex", alignItems: "center", gap: 8,
                background: "rgba(16,185,129,0.15)",
                border: "1px solid rgba(16,185,129,0.3)",
                color: BRAND_ACCENT_COLOR,
                fontSize: "0.82rem", fontWeight: 700,
                borderRadius: 999, padding: "0.35rem 0.9rem",
                marginBottom: "1.4rem", letterSpacing: "0.04em",
              }}
            >
              <span style={{ fontSize: "0.95rem" }}>💬</span> SMS CAMPAIGNS
            </div>

            <h1
              style={{
                fontSize: isMobile ? "2.1rem" : "3.2rem",
                fontWeight: 800,
                color: "#fff",
                lineHeight: 1.1,
                letterSpacing: "-0.02em",
                marginBottom: "1.2rem",
              }}
            >
              <span
                style={{
                  background: "linear-gradient(90deg, #10b981 0%, #3b82f6 100%)",
                  WebkitBackgroundClip: "text", backgroundClip: "text", color: "transparent",
                }}
              >98%</span> of your SMS get opened.
              <br />
              The other 2% changed numbers.
            </h1>

            <p
              style={{
                fontSize: isMobile ? "1rem" : "1.15rem",
                color: "rgba(255,255,255,0.75)",
                lineHeight: 1.7,
                marginBottom: "1.6rem",
                maxWidth: 520,
              }}
            >
              Wake up cold leads and past appraisals with a quarterly{" "}
              <span style={{ color: "#fff", fontWeight: 600 }}>personalised value update</span>, straight to their pocket, branded to your agency, with a link to their own AI report.
            </p>

            <div
              style={{
                display: "flex",
                gap: "0.75rem",
                flexDirection: isMobile ? "column" : "row",
                marginBottom: "1.5rem",
              }}
            >
              <button
                style={ctaPrimary}
                onClick={() => setShowSignIn(true)}
                onMouseOver={(e) => { e.currentTarget.style.transform = "translateY(-1px)"; e.currentTarget.style.boxShadow = "0 6px 20px rgba(16,185,129,0.5)"; }}
                onMouseOut={(e) => { e.currentTarget.style.transform = "translateY(0)"; e.currentTarget.style.boxShadow = "0 4px 14px rgba(16,185,129,0.4)"; }}
              >
                Start a campaign →
              </button>
              <button
                style={ctaSecondary}
                onClick={() => setShowContact(true)}
                onMouseOver={(e) => (e.currentTarget.style.background = "rgba(255,255,255,0.15)")}
                onMouseOut={(e) => (e.currentTarget.style.background = "rgba(255,255,255,0.08)")}
              >
                Talk to us
              </button>
            </div>

            {/* mini KPIs */}
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "repeat(2, 1fr)",
                gap: 14,
                maxWidth: 360,
                marginTop: 12,
              }}
            >
              {[
                { v: "3 min", l: "median read time" },
                { v: "11%", l: "reply-back on cold lists" },
              ].map((k, i) => (
                <div
                  key={i}
                  style={{
                    background: "rgba(255,255,255,0.06)",
                    border: "1px solid rgba(255,255,255,0.08)",
                    borderRadius: 12,
                    padding: "10px 12px",
                  }}
                >
                  <div style={{ color: "#fff", fontWeight: 800, fontSize: 18 }}>{k.v}</div>
                  <div style={{ color: "rgba(255,255,255,0.6)", fontSize: 11, marginTop: 2 }}>{k.l}</div>
                </div>
              ))}
            </div>
          </div>

          {/* Right phone */}
          <div style={{ display: "flex", justifyContent: "center", position: "relative" }}>
            <HeroLiveScene isMobile={isMobile} />
          </div>
        </div>
      </header>

      {/* sub-hero pitch strip */}
      <section
        style={{
          background: "#fff",
          padding: isMobile ? "2.5rem 1.5rem" : "3.5rem 2rem",
          borderBottom: "1px solid #f1f5f9",
        }}
      >
        <div style={{ maxWidth: 880, margin: "0 auto", textAlign: "center" }}>
          <div
            style={{
              fontSize: isMobile ? "1.3rem" : "1.7rem",
              fontWeight: 700,
              color: BRAND_COLOR,
              lineHeight: 1.45,
              letterSpacing: "-0.01em",
            }}
          >
            Your CRM is full of homeowners who don't open your emails. They <span style={{ color: BRAND_ACCENT_COLOR }}>all</span> open their messages.
          </div>
          <div
            style={{
              marginTop: 12,
              fontSize: "1rem",
              color: GRAY_DARK_COLOR,
              lineHeight: 1.7,
              maxWidth: 640,
              margin: "12px auto 0",
            }}
          >
            Vendorleads quietly re-engages every past appraisal and cold lead with a personalised value update, quarterly, automatically, branded to you.
          </div>
        </div>
      </section>

      {/* ─── STORY 1: segmenting ─── */}
      <StoryBlock
        isMobile={isMobile}
        kicker="Step 1 · Segment"
        title="Smart segments built from your CRM."
        body="Vendorleads sorts your contacts the moment they sync. Past appraisals, cold leads, past clients, so every SMS lands in the right pocket with the right context."
        bullets={[
          "Auto-segmented from appraisal history & lead source",
          "Mobile-only contacts get a different message path",
          "One-click filters: send to one segment, all of them, or a custom slice",
        ]}
        media={<SegmentingAnimation isMobile={isMobile} />}
      />

      {/* ─── STORY 2: AI drafting ─── */}
      <StoryBlock
        isMobile={isMobile}
        reversed
        kicker="Step 2 · Personalise"
        title="AI writes every SMS like you would, one to one."
        body="No more 'Hi {first_name}'. AI pulls each contact's address, suburb trend, and report link, then writes a tight 160-character message that reads like it came from you alone."
        bullets={[
          "Pulls live address + market data per contact",
          "Branded short-link to their personal AI report",
          "Tone-tuned to your voice, capped at one SMS segment",
        ]}
        media={<AiDraftingAnimation isMobile={isMobile} />}
      />

      {/* ─── STORY 3: send wave ─── */}
      <StoryBlock
        isMobile={isMobile}
        kicker="Step 3 · Send"
        title="Send a wave. Watch the ticks roll in."
        body="Throttled delivery, carrier-compliant short codes, opt-out handling. Live delivery and read receipts stream back so you know who saw it and when."
        bullets={[
          "Throttled wave-send for healthy delivery rates",
          "Live delivered & read receipts in the dashboard",
          "Auto opt-out · STOP & quiet hours handled for you",
        ]}
        media={<SendWaveAnimation isMobile={isMobile} />}
      />

      {/* ─── STORY 4: click-through to valuation page ─── */}
      <StoryBlock
        isMobile={isMobile}
        reversed
        kicker="Step 4 · Convert"
        title="One tap from pocket to private appraisal."
        body="Every link points at your branded AI valuation report. When they tap, you get the tap. When they request a private appraisal, the lead lands in your CRM with full context."
        bullets={[
          "Every link is agency-branded with your logo & colours",
          "Click-tracking + UTM stitched to the contact",
          "Appraisal requests sync straight to your CRM",
        ]}
        media={<ClickThroughAnimation isMobile={isMobile} />}
      />

      {/* ─── STORY 5: two-way ─── */}
      <StoryBlock
        isMobile={isMobile}
        kicker="Step 5 · Reply"
        title="Replies don't get lost. AI drafts. You approve."
        body="When a homeowner texts back, AI reads the conversation, drafts a contextual reply, and waits for your tap. The warmth of a personal SMS, at portfolio scale."
        bullets={[
          "Inbound replies routed into one unified inbox",
          "AI suggests the response, with full chat context",
          "Human-in-the-loop · you approve before anything sends",
        ]}
        media={<TwoWayReplyScene isMobile={isMobile} />}
      />

      {/* ─── Channel comparison ─── */}
      <section
        style={{
          padding: isMobile ? "3rem 1.5rem" : "5rem 2rem",
          background: "#0b1220",
          borderTop: "1px solid #f1f5f9",
        }}
      >
        <div style={{ maxWidth: 1100, margin: "0 auto", textAlign: "center" }}>
          <Kicker colour={BRAND_ACCENT_COLOR}>Why SMS wins</Kicker>
          <h2
            style={{
              fontSize: isMobile ? "1.7rem" : "2.2rem",
              fontWeight: 800,
              color: "#fff",
              marginBottom: "0.6rem",
              letterSpacing: "-0.01em",
              lineHeight: 1.2,
            }}
          >
            Email gets ignored. SMS gets read in 3 minutes.
          </h2>
          <p style={{ color: "rgba(255,255,255,0.65)", fontSize: "1rem", lineHeight: 1.6, maxWidth: 640, margin: "0 auto 2rem" }}>
            For the same cold-lead list, here's what we see across thousands of agency campaigns.
          </p>

          <div
            style={{
              display: "grid",
              gridTemplateColumns: isMobile ? "1fr" : "repeat(3, 1fr)",
              gap: 16,
              marginTop: 32,
            }}
          >
            {[
              { ch: "Email", open: 18, click: 1.2, reply: 0.4, colour: "#94a3b8" },
              { ch: "Phone call", open: 22, click: null, reply: 6, colour: "#fbbf24" },
              { ch: "SMS", open: 98, click: 24, reply: 11, colour: BRAND_ACCENT_COLOR, highlight: true },
            ].map((row) => (
              <div
                key={row.ch}
                style={{
                  background: row.highlight ? "rgba(16,185,129,0.10)" : "rgba(255,255,255,0.04)",
                  border: `1px solid ${row.highlight ? "rgba(16,185,129,0.4)" : "rgba(255,255,255,0.08)"}`,
                  borderRadius: 16,
                  padding: 20,
                  position: "relative",
                  overflow: "hidden",
                }}
              >
                {row.highlight && (
                  <div
                    style={{
                      position: "absolute", top: 10, right: 10,
                      fontSize: 9, fontWeight: 800, color: BRAND_ACCENT_COLOR,
                      background: "rgba(16,185,129,0.2)", padding: "3px 7px",
                      borderRadius: 999, letterSpacing: 0.5,
                    }}
                  >WINNER</div>
                )}
                <div style={{ color: row.colour, fontSize: 13, fontWeight: 800, letterSpacing: 0.5, marginBottom: 10 }}>
                  {row.ch.toUpperCase()}
                </div>
                <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
                  <Stat label="Open / pickup" value={`${row.open}%`} pct={row.open} colour={row.colour} />
                  {row.click !== null && (
                    <Stat label="Click-through" value={`${row.click}%`} pct={row.click * 3} colour={row.colour} />
                  )}
                  <Stat label="Reply-back" value={`${row.reply}%`} pct={row.reply * 8} colour={row.colour} />
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ─── ROI band ─── */}
      <section
        style={{
          padding: isMobile ? "3rem 1.5rem" : "4.5rem 2rem",
          background: "#fff",
        }}
      >
        <div
          style={{
            maxWidth: 1100, margin: "0 auto",
            display: "grid",
            gridTemplateColumns: isMobile ? "1fr" : "1fr 1fr 1fr",
            gap: 18,
          }}
        >
          {[
            { stat: "1 listing", body: "pays for SMS campaigns for years.", colour: BRAND_ACCENT_COLOR },
            { stat: "0 minutes", body: "of your time once the cadence is set.", colour: BRAND_BLUE },
            { stat: "4 a year", body: "quarterly waves. Always-on warmth.", colour: "#a855f7" },
          ].map((s, i) => (
            <div
              key={i}
              style={{
                background: "#f8fafc",
                border: "1px solid #e2e8f0",
                borderRadius: 16,
                padding: 24,
              }}
            >
              <div style={{ fontSize: 32, fontWeight: 800, color: s.colour, lineHeight: 1 }}>{s.stat}</div>
              <div style={{ marginTop: 10, color: GRAY_DARK_COLOR, fontSize: "1rem", lineHeight: 1.55 }}>
                {s.body}
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* ─── Final CTA ─── */}
      <section
        style={{
          background: heroBg,
          padding: isMobile ? "3.5rem 1.5rem" : "5rem 2rem",
          textAlign: "center",
          position: "relative",
          overflow: "hidden",
        }}
      >
        <div
          style={{
            position: "absolute", inset: 0,
            backgroundImage:
              "linear-gradient(rgba(255,255,255,0.03) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.03) 1px, transparent 1px)",
            backgroundSize: "60px 60px",
            pointerEvents: "none",
          }}
        />
        <div style={{ maxWidth: 680, margin: "0 auto", position: "relative", zIndex: 1 }}>
          <h2
            style={{
              fontSize: isMobile ? "1.9rem" : "2.6rem",
              fontWeight: 800,
              color: "#fff",
              marginBottom: "1rem",
              lineHeight: 1.15,
              letterSpacing: "-0.02em",
            }}
          >
            Re-wake every cold lead in your CRM by Friday.
          </h2>
          <p style={{ color: "rgba(255,255,255,0.7)", marginBottom: "1.8rem", fontSize: "1.05rem", lineHeight: 1.6 }}>
            Setup takes 4 minutes. Your first wave goes out the same day.
          </p>
          <div style={{ display: "flex", gap: 12, justifyContent: "center", flexDirection: isMobile ? "column" : "row", alignItems: isMobile ? "stretch" : "center" }}>
            <button
              style={ctaPrimary}
              onClick={() => setShowSignIn(true)}
              onMouseOver={(e) => { e.currentTarget.style.transform = "translateY(-1px)"; e.currentTarget.style.boxShadow = "0 6px 20px rgba(16,185,129,0.5)"; }}
              onMouseOut={(e) => { e.currentTarget.style.transform = "translateY(0)"; e.currentTarget.style.boxShadow = "0 4px 14px rgba(16,185,129,0.4)"; }}
            >
              Get started
            </button>
            <button
              style={ctaSecondary}
              onClick={() => setShowContact(true)}
              onMouseOver={(e) => (e.currentTarget.style.background = "rgba(255,255,255,0.15)")}
              onMouseOut={(e) => (e.currentTarget.style.background = "rgba(255,255,255,0.08)")}
            >
              Book a 15-min walkthrough
            </button>
          </div>
        </div>
      </section>

      {showSignIn && <SignInModal show={showSignIn} onHide={() => setShowSignIn(false)} />}
      {showContact && <ContactVendorleadsModal show={showContact} onHide={() => setShowContact(false)} />}
    </div>
  );
}

/* ─────────── Stat bar ─────────── */
function Stat({ label, value, pct, colour }) {
  return (
    <div>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "baseline", marginBottom: 4 }}>
        <span style={{ color: "rgba(255,255,255,0.6)", fontSize: 11 }}>{label}</span>
        <span style={{ color: "#fff", fontWeight: 700, fontSize: 13 }}>{value}</span>
      </div>
      <div style={{ height: 6, borderRadius: 999, background: "rgba(255,255,255,0.08)", overflow: "hidden" }}>
        <div
          style={{
            height: "100%",
            width: `${Math.min(100, pct)}%`,
            background: colour,
            borderRadius: 999,
            transition: "width 0.6s ease",
          }}
        />
      </div>
    </div>
  );
}

/* ─────────── Button styles ─────────── */
const ctaPrimary = {
  border: "none",
  borderRadius: 8,
  padding: "0.9rem 1.8rem",
  fontSize: "1rem",
  fontWeight: 700,
  cursor: "pointer",
  background: BRAND_ACCENT_COLOR,
  color: "#fff",
  boxShadow: "0 4px 14px rgba(16,185,129,0.4)",
  transition: "transform 0.15s, box-shadow 0.15s",
};

const ctaSecondary = {
  border: "1px solid rgba(255,255,255,0.25)",
  borderRadius: 8,
  padding: "0.9rem 1.8rem",
  fontSize: "1rem",
  fontWeight: 600,
  cursor: "pointer",
  background: "rgba(255,255,255,0.08)",
  color: "#fff",
  transition: "background 0.15s",
};
